const KPI_CARD_SUBTITLE_BY_KEY = {
  effectiveness: '% de atenciones válidas',
  'active-users': 'Usuarios con actividad',
  geofence: 'Visitas dentro de geocerca',
  settlements: 'Usuarios que ya liquidaron',
  'pos-task': 'Tareas ejecutadas',
  'effective-visits': 'Porcentaje de visitas efectivas',
  'delivered-docs': 'Porcentaje de documentos entregados'
}

const KPI_CARD_SUBTITLE_BY_TITLE = {
  Efectividad: '% de atenciones válidas',
  'Usuarios activos': 'Usuarios con actividad',
  'Actividad dentro de geocerca': 'Visitas dentro de geocerca',
  'Actividades dentro de geocerca': 'Visitas dentro de geocerca',
  Liquidaciones: 'Liquidaciones realizadas',
  'Usuarios con liquidación': 'Usuarios que ya liquidaron',
  'Tareas en punto de venta': 'Tareas ejecutadas',
  'Visitas realizadas': 'Clientes visitados vs Clientes atendidos',
  'Visitas fuera de ruta': 'Clientes fuera del recorrido',
  'Visitas efectivas': 'Porcentaje de visitas efectivas',
  'Documentos entregados': 'Porcentaje de documentos entregados',
  'Docs. entregados (Cobros)': 'Porcentaje de documentos entregados',
  'Docs. entregados (Entregas)': 'Porcentaje de documentos entregados'
}

export const TOTALS_SECTION_TITLE = 'TOTALES'

export const getKpiCardSubtitle = ({ cardKey, title }) =>
  KPI_CARD_SUBTITLE_BY_KEY[cardKey] || KPI_CARD_SUBTITLE_BY_TITLE[title]

const TIMESTAMP_CARD_SUBTITLE_BY_TITLE = {
  'Hora de primera visita': {
    sameDay: 'Inicio de jornada',
    range: 'Disponible solo por dia'
  },
  'Hora de última visita': {
    sameDay: 'Cierre de jornada',
    range: 'Disponible solo por dia'
  },
  'Duración total de visitas': {
    sameDay: 'Tiempo acumulado del dia'
  },
  'Tiempo promedio de visita': {
    range: 'Promedio por visita'
  }
}

export const getTimestampCardSubtitle = ({ title, isSameDay }) => {
  const subtitleConfig = TIMESTAMP_CARD_SUBTITLE_BY_TITLE[title]
  if (!subtitleConfig) return undefined

  return isSameDay ? subtitleConfig.sameDay || subtitleConfig.range : subtitleConfig.range
}
